import { Menu } from '@mui/material';
import React from 'react';

export function useBannerMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    isOpen,
    handleClick,
    handleClose,
  }
}

export default function BannerMenu(
  {
    anchorEl,
    isOpen,
    handleClose,
    children,
  }: {
    anchorEl: ReturnType<typeof useBannerMenu>['anchorEl']
    isOpen: ReturnType<typeof useBannerMenu>['isOpen']
    handleClose: ReturnType<typeof useBannerMenu>['handleClose']
    children: React.ReactNode
  }) {
  return (
    <Menu
      anchorEl={anchorEl}
      id="banner-menu"
      open={isOpen}
      onClose={handleClose}
      onClick={handleClose}
      disableScrollLock={true}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflowY: 'auto',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: -15,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {children}
    </Menu>
  );
};  